import React, { useRef } from "react";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineShareAlt,
} from "react-icons/ai";

import { Link } from "react-router-dom";
import { CiClock1 } from "react-icons/ci";
import { BiMessageDetail } from "react-icons/bi";
import Slider from "react-slick";

const OurStores = () => {
  const arroww1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/2023-annual report.pdf";
  const rfp = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RFP_Thumbnail.png";
  const addendum = "https://izbassetsmain.blob.core.windows.net/izbwebassets/addendum-Thumbnail_2.png";
  const job = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumb_Image.png";
  const solarTender = "https://izbassetsmain.blob.core.windows.net/izbwebassets/27-11-Solar_Tender.png";
  const izb2025 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumbnail-IZB-2025k.png";
  const career = "https://izbassetsmain.blob.core.windows.net/izbwebassets/EMPLOYMENT AND CAREER DEVELOPMENT OPPORTUNITIES-Thumbnail.png";
  const customerNotice = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumbnail-Customer Notice.png";
  const customerNotice1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Customer_Notice_1-thumbnail.png";

  const customerNotice2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Thumbnail_Notes.png";
  const customerNotice3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-invites-bids-for-the-sale-of-the-following-cover-vehicles.png";
  const customerNotice4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-to-tender-for-the-furbishment-and-fitout-works-of-proposed-izb-branches-cover-banner.png";

  const customerNotice5 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0519_%20izb-property-Letter-cover.png";

  const customerNotice6 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Unwarranted-Charges-And-Fees-Banner.png";

  const customerNotice7 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/CUSTOMER-ENTITLEMENTS-AND-RESPONSIBILITIES-Banner.png";

  const customerNotice8 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_dormat_acount_reactivation_campaign.png";

  const customerNotice9 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_forex_table_revision_thumbnaill.png";

  const customerNotice10 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-clinches-hat-trick-of-provincial-exhibition-awards-thumbnail.png";

  const customerNotice11 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-clinches-another-hat-trick-of-top-honours-thumbnail.png";

  const customerNotice12 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-at-top-of-the-game-in-chingola-thumbnail.png";

  const customerNotice13 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Savings_Products_2024_banner.png";

  const customerNotice14 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-for-proposals-for-consulting-services-job-evaluation-of-the-izb-thumb.png";

  const customerNotice15 ="https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-for-bids-fitout-works-of-proposed-mazabuka-branch-thumb.png"

  const customerNotice16 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1106_ property_Letter_v1_Artboard-02-thumb.png";

  const customerNotice17 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/your-next-gen-digital-banking-experience-is-here-thumb.jpg"

  const customerNotice18 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/upgraded-versions-of-our-retail-and-corporate-banking-services-thumb.png"


  const sliderRef = useRef(null);
  // console.log(sliderRef.current);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section>
      <div className="container notice-and-announcements">
        <div className="row">
          <div className="container">
            <div className="heading py-2">
              <h2 className="text-center">Notice / Announcements</h2>
              {/* <p className="text-center">All News And Updates</p> */}
            </div>
            <div
              className="py-4 read-more-flot-btn"
            // style={{ float: "right"}}
            >
              <Link
                to="/NoticeAnnouncements"
                className="text-white rounded px-3 py-1"
                style={{ backgroundColor: "#9E1B1E" }}
              >
                See More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
              </Link>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/upgraded-versions-of-our-retail-and-corporate-banking-services-banner.png" target="_blank">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice18} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>

              <div className="text-holder">
                <h3 className="blog-title">

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/upgraded-versions-of-our-retail-and-corporate-banking-services-banner.png" target="_blank">
                    UPGRADED VERSIONS OF OUR RETAIL AND CORPORATE...
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>November 05, 2025</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  Indo Zambia Bank has successfully conducted a planned System Upgrade, and we are pleased to advise that the upgraded versions of the Retail and Corporate Banking Services are now operational.
                </p>

                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/upgraded-versions-of-our-retail-and-corporate-banking-services-banner.png" target="_blank">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>

            </div>
          </div>

          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/your-next-gen-digital-banking-experience-is-here.pdf" target="_blank">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice17} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>

              <div className="text-holder">
                <h3 className="blog-title">

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/your-next-gen-digital-banking-experience-is-here.pdf" target="_blank">
                    Your Next-Gen Digital Banking Experience is Here!
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>October 20, 2025</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  Indo Zambia Bank presents IZB NXT – the Next-Gen Digital Banking App. This digital transformation brings you. A sleek, user-friendly interface for intuitive navigation. Smarter, faster banking capabilities to manage your money instantly...

                </p>

                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/your-next-gen-digital-banking-experience-is-here.pdf" target="_blank">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>

            </div>
          </div>

          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1106_ property_Letter_v1_Artboard-02-banner.jpg" target="_blank">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice16} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>

              <div className="text-holder">
                <h3 className="blog-title">

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1106_ property_Letter_v1_Artboard-02-banner.jpg" target="_blank">
                    PROPERTIES FOR SALE <br/>
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>September 08, 2025</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  INDO ZAMBIA BANK LIMITED as mortgagees in possession is inviting bids from interested parties for purchase of the following properties on “as is where is basis.” Interested parties may purchase the bidding...
                </p>

                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1106_ property_Letter_v1_Artboard-02-banner.jpg" target="_blank">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default OurStores;
